// extracted by mini-css-extract-plugin
export default {"wrapper":"Articles_wrapper__UFksL","title":"Articles_title__J7WM6","cards":"Articles_cards__0FUT3"};